import { styled } from "styled-components"
import { useNavigate } from "react-router-dom"
import { useAuthLogin } from "../../../hooks/useAuth"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import loginFormSchema from "./loginFormSchema"
import { StyledButton } from "../../common/Buttons"
import { TextDiv, TextInput, UnderlinedTextButton } from "../../common/Text"

interface LoginFormValues {
  username: string
  password: string
}

const LoginForm = () => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm<LoginFormValues>({
    defaultValues: { username: "", password: "" },
    resolver: yupResolver(loginFormSchema),
    mode: "onSubmit",
  })

  const { mutate } = useAuthLogin()

  const login = handleSubmit((data) => {
    mutate(data)
  })

  const handleForgetPW = () => {
    navigate("/user/findpw")
  }

  return (
    <LoginContainer>
      <TextDiv fontSize={30} $align="start" fontWeight="bold">
        로그인
      </TextDiv>
      <LoginFormContainer onSubmit={login}>
        <div>
          <TextInput
            $isError={errors.username ? true : false}
            placeholder="e-mail"
            {...register("username")}
          />
          {errors.username && (
            <TextDiv
              fontSize={11}
              color="var(--custom-light-red)"
              $align="start"
              style={{ marginTop: 10, marginLeft: 25 }}
            >
              * {errors.username.message}
            </TextDiv>
          )}
        </div>
        <div>
          <TextInput
            $isError={errors.password ? true : false}
            placeholder="비밀번호"
            type="password"
            {...register("password")}
          />
          {errors.password && (
            <TextDiv
              fontSize={11}
              color="var(--custom-light-red)"
              $align="start"
              style={{ marginTop: 10, paddingLeft: 25 }}
            >
              * {errors.password.message}
            </TextDiv>
          )}
        </div>
        <StyledButton $size="large" type="submit" disabled={isSubmitting}>
          로그인
        </StyledButton>
        <UnderlinedTextButton
          fontSize={11}
          color="var(--custom-blue)"
          style={{ alignSelf: "flex-end" }}
          onClick={handleForgetPW}
        >
          비밀번호 찾기
        </UnderlinedTextButton>
      </LoginFormContainer>
    </LoginContainer>
  )
}

export default LoginForm

const LoginContainer = styled.div`
  box-sizing: border-box;
  width: 100vw;
  height: 100%;
  padding: 60px 35px;
  display: flex;
  flex-direction: column;
  gap: 50px;

  @media ${({ theme }) => theme.device.pc} {
    width: 40vw;
    margin: 0 auto;
    gap: 70px;
  }
`

const LoginFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;

  @media ${({ theme }) => theme.device.pc} {
    gap: 40px;
  }
`
